import { logout } from '../slices/authSlice';

import { apiSlice } from '../slices/apiSlice'; 


let timerId;

// beforeLogout is an optional async function to call before dispatching logout
export const startAuthTimer = (dispatch, navigate, beforeLogout) => {
  clearAuthTimer();

  timerId = setInterval(async () => {
    const expirationTime = localStorage.getItem('expirationTime');
    if (!expirationTime) return;

    const currentTime = new Date().getTime();

    if (currentTime > expirationTime) {
      clearAuthTimer();

      if (beforeLogout) {
        try {
          await beforeLogout();
        } catch (_) {
          // Never block logout if audit call fails
        }
      }

      dispatch(logout());
      dispatch(apiSlice.util.resetApiState()); 
      navigate('/login');
    }
  }, 60000);
};

export const clearAuthTimer = () => {
  if (timerId) {
    clearInterval(timerId);
  }
};